

<div class="heads h-[70px] hidden sm:hidden md:hidden lg:block">
  <div
    class="head justify-between flex w-full h-[72px] pt-[15px] pb-[48px] pr-[30px] pl-[15px] mt-[10px]">
    <div class="first-container justify-between flex w-3/4 px-4 gap-4">
      <div
        class="frame-15 h-[42px] sm:hidden md:hidden lg:block flex items-center w-full gap-2">
        <h1
          class="txt font-medium leading-6 h-6 text-[18px] tracking-[-0.2px] text-[#4E5459] text-left">
          {{ mainLayouService.board() }}
        </h1>
      </div>
      <div
        class="actions justify-between flex h-[40px] sm:hidden md:hidden lg:block">
      </div>
    </div>
    <div class="a-side w-1/4 px-[15px] pb-10 gap-[18px]">
      <div class="aside-header flex justify-end items-center">
        <div class="profile items-center flex h-[48px] gap-9 mr-4">
          <div
            class="flex w-[110px] h-[50px] gap-[10px] justify-end items-center">
            <div
              class="w-[40px] h-[40px] bg-primary rounded-[50%] flex items-center justify-center text-white font-bold">
              {{ headerService.userName().email | avator: 1 }}
            </div>
          </div>
        </div>
        <div class="drop-menu w-[18px] h-[18px]">
          <div
            type="button"
            class="menu-icon w-[18px] h-[18px]"
            (click)="openModal($event)"
            [attr.aria-hidden]="true"></div>
          <div
            id="pop-menu"
            class="demobox hidden shadow-2xl absolute right-8 top-5 max-h-fit bg-[#fff] rounded-[20px] gap-[10px] z-50"
            (click)="closeModal($event)"
            [attr.aria-hidden]="true">
            <div class="close-icon pt-5 w-[18px] h-[18px] pl-[264px]">
              <button
                type="button"
                class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                <svg
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                  class="w-3 h-3">
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"></path>
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
            </div>
            <div
              class="dropdown-content h-6 pb-[30px] pt-[5px] pl-10 z-auto"
              id="closeModal">
              <div
                class="modal-content flex justify-start items-center hover:font-bold text-xs font-normal leading-[14.52px] text-left text-[rgba(163, 166, 169, 1)] gap-[10px]">
                <img
                  class="icon-img stroke-1 md:stroke-2 w-[12.67px] h-[18px] left-[3px] cursor-pointer"
                  src="assets/profile-icon.svg"
                  alt="profile" />
                <a
                  [routerLink]="'profile'"
                  class="text-[rgba(163, 166, 169, 1)] hover:text-base hover:text-primary">
                 {{' Profile' |titlecase}}
                </a>
              </div>
            </div>

            <div class="dropdown-content h-6 pb-[30px] pt-[5px] pl-10">
              <div
                class="modal-content flex justify-start items-center hover:font-bold text-xs font-normal leading-[14.52px] text-left text-[rgba(163, 166, 169, 1)] gap-[10px]">
                <img
                  class="icon-img stroke-1 md:stroke-2 w-[12.67px] h-[18px] left-[3px] cursor-pointer"
                  src="assets/benficiaries-icon.svg"
                  alt="beneficiaries" />
                <a
                  [routerLink]="''"
                  class="text-[rgba(163, 166, 169, 1)] hover:text-base hover:text-primary">
                 {{' work' |titlecase}}
                </a>
              </div>
            </div>

            <div class="dropdown-content h-6 pb-[30px] pt-[5px] pl-10">
              <div
                class="modal-content flex justify-start items-center hover:font-bold text-xs font-normal leading-[14.52px] text-left text-[rgba(163, 166, 169, 1)] gap-[10px]">
                <img
                  class="icon-img stroke-1 md:stroke-2 w-[12.67px] h-[18px] left-[3px] cursor-pointer"
                  src="assets/support-icon.svg"
                  alt="support" />
                <a
                  [routerLink]=""
                  class="text-[rgba(163, 166, 169, 1)] hover:text-base hover:text-primary">
                 {{' Support' |titlecase}}                   
                </a>
              </div>
            </div>
            <div
              class="dropdown-content h-6 pb-[30px] pt-[5px] pl-10 border-t-gray-200 border-t-2 cursor-pointer hover:scale-110">
              <div
                class="modal-content flex justify-start items-center hover:font-bold text-xs font-normal leading-[14.52px] text-left text-[rgba(163, 166, 169, 1)] gap-[10px]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="18px"
                  viewBox="0 -960 960 960"
                  width="13px"
                  fill="#5f6368">
                  <path
                    d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z" />
                </svg>

                <a
                  (click)="logout()"
                  class="text-[rgba(163, 166, 169, 1)] hover:text-base hover:text-primary">
                 {{' Logout' |titlecase}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
